export enum InframailIpStatus {
  Pending = 'pending',
  InProgress = 'inProgress',
  Active = 'active',
  Deleted = 'deleted',
  Failed = 'failed',
}

export enum InframailIpAction {
  DELETE = 'delete',
  REVOKE = 'revoke',
}
